import React, { useState } from 'react';
import { Link } from 'react-router-dom';
import Typewriter from 'typewriter-effect';
import { useInView } from 'react-intersection-observer';
import { motion, AnimatePresence } from 'framer-motion';

import { leaders, leaderPath, cvExcerpt } from '../../data/leaders';
import ContactForm from '../partials/ContactForm';

const Home = () => {

    const { ref: bannerRef, inView: bannerInView } = useInView({
        triggerOnce: false,
        threshold: 0.5,
    });
    const [selectedLeader, setSelectedLeader] = useState(null);
    const [isModalOpen, setIsModalOpen] = useState(false);

    const formatServiceDesc = (desc) => {
        const items = desc.split('•').map(item => item.trim()).filter(Boolean);
        const chunks = [];

        for (let i = 0; i < items.length; i += 3) {
            chunks.push(items.slice(i, i + 3));
        }

        return chunks.map((chunk, index) => (
            <span key={index} className="d-block">
            • {chunk.join(' • ')}
        </span>
        ));
    };

    const glowMethods = [
        {
            num: '01',
            title: 'Ground',
            desc: 'Clarifies the real problems with precision',
            letter: 'G'
        },
        {
            num: '02',
            title: 'Lead',
            desc: 'Provides clear & local strategic direction',
            letter: 'L'
        },
        {
            num: '03',
            title: 'Operate',
            desc: 'Gets hands-on and executes effectively by senior leadership experience',
            letter: 'O'
        },
        {
            num: '04',
            title: 'Win',
            desc: 'Scales impact and builds sustainable growth',
            letter: 'W'
        }
    ];

    const services = [
        {
            id: '01',
            title: 'Strategic Direction',
            desc: '• Brand Strategy • Market Research • Competition Analysis • Go To Market • Financial Reporting • KPI & Review'
        },
        {
            id: '02',
            title: 'Operational Execution',
            desc: '• PL - Budget - Cash Flow • S&OP Process • Forecasting • Service Rate & KPI Mng • Import & Export Process'
        },
        {
            id: '03',
            title: 'Omni-Channel Management',
            desc: '• O+O Commercial Mgmnt • Online MP Execution • Monobrand Store & Brand.com • FMCG Channel Management • Selective Channels'
        },
        {
            id: '04',
            title: 'Trade & Shopper Marketing',
            desc: '• Field Team Service • (Sales - BA - Merchandiser) • Best Shopping Exp. Reporting • (OSA - Planogram - Qualitative KPI\'s)'
        },
        {
            id: '05',
            title: '360° Marketing Communication Management',
            desc: '• Marcom • Social Media Man. • Digital Content Creation • Influencer Marketing • Retail Media • Digital Marketing'
        }
    ];

    const brands = [
        {name: "L'Oréal", img: "/site/assets/img/loreal.png"},
        {name: "Sephora", img: "/site/assets/img/sephora.png"},
        {name: "Flormar", img: "/site/assets/img/flormar.png"},
        {name: "Trendyol", img: "/site/assets/img/trendyol.png"},
        {name: "Reckitt", img: "/site/assets/img/reckitt.png"},
        {name: "Reckitt", img: "/site/assets/img/sh.png"},
        {name: "Reckitt", img: "/site/assets/img/unilever.png"},

    ];


    // Kart gercek bir <Link>. Duz sol tikta modal aciliyor (mevcut UX korunuyor),
    // yeni sekmede acma / orta tik / crawler'lar ise /team/<slug> sayfasina gidiyor.
    const handleLeaderClick = (event, leader) => {
        if (event.metaKey || event.ctrlKey || event.shiftKey || event.altKey || event.button !== 0) return;
        if (!leader.cv) return;
        event.preventDefault();
        openLeaderModal(leader);
    };

    const openLeaderModal = (leader) => {
        if (leader.cv) {
            setSelectedLeader(leader);
            setIsModalOpen(true);
            document.body.style.overflow = 'hidden';
        }
    };

    const closeLeaderModal = () => {
        setIsModalOpen(false);
        setTimeout(() => setSelectedLeader(null), 300);

        document.body.style.overflow = '';
    };

    // Modalda tam CV degil ozet gosteriliyor; tam metin /team/<slug> sayfasinda.
    const excerpt = selectedLeader ? cvExcerpt(selectedLeader) : null;

    return (
        <>

            <section id={'home-banner'}>
                <div className={'container h-100 align-content-center'}>
                    <div className={'hero-description-area'}>

                        <div className={'hero-description-title'} ref={bannerRef}>
                            {bannerInView && (
                                <Typewriter
                                    onInit={(typewriter) => {
                                        typewriter
                                            .typeString('we make <span class="glowork-pink-color">beauty</span> work')
                                            .callFunction((state) => {
                                                state.elements.cursor.style.display = 'none';
                                            })
                                            .start();
                                    }}
                                    options={{
                                        delay: 100,
                                        cursor: '|',
                                    }}
                                />
                            )}
                        </div>

                        <motion.div
                            initial={{ opacity: 0, y: 30 }}
                            whileInView={{ opacity: 1, y: 0 }}
                            viewport={{ once: false, amount: 0.5 }}
                            transition={{ duration: 0.6, delay: 0.2 }}
                        >
                            <p className={'hero-description mt-3'}>
                                Gloworks builds, operates, and scales beauty and personal care brands with a senior
                                leadership team that is as close to execution as it is to strategy.
                            </p>

                            <div className={'d-flex flex-column flex-md-row gap-3 mt-4'}>
                                <a href={'/#home-leadership'} className={'btn px-4 hero-meet-btn py-2'}>
                                    MEET THE TEAM{' '}
                                    <i className="bi bi-arrow-up-right btn-icon ms-2"></i>
                                </a>

                                <a href={'/#home-scope-service'} className={'btn px-4 hero-explore-btn py-2'}>
                                    EXPLORE SERVICES{' '}
                                    <i className="bi bi-arrow-up-right btn-icon ms-2"></i>
                                </a>
                            </div>
                        </motion.div>

                    </div>
                </div>
            </section>

            <section id={'home-method'} className={'pb-3 pb-lg-5'}>
                <div className={'container py-5 py-lg-5'}>
                    <div className={'row g-1 g-lg-5'}>
                        <motion.div
                            className={'col-12 col-md-3'}
                            initial={{ opacity: 0, x: -50 }}
                            whileInView={{ opacity: 1, x: 0 }}
                            viewport={{ once: false, amount: 0.2 }}
                            transition={{ duration: 0.6 }}
                        >
                            <div className="glow-method-wrapper">
                                <h5 className="glowMethod">THE GLOW METHOD</h5>
                                <div className="glow-underline-container">
                                    <span className="glow-line"></span>
                                    <img
                                        src="/site/assets/img/glow-star.png"
                                        alt="Glow Star"
                                        className="glow-star-icon"
                                    />
                                </div>
                            </div>
                            <p className={'text-muted small mb-4'}>
                                GloworKs is a team powered by
                                a distinguished advisory board of
                                industry experts and a strategic
                                operational framework, dedicated
                                to building, operating, and scaling
                                beauty and personal care brands.
                            </p>
                        </motion.div>
                        <motion.div
                            className={'col-12 col-md-6'}
                            initial={{ opacity: 0, x: 50 }}
                            whileInView={{ opacity: 1, x: 0 }}
                            viewport={{ once: false, amount: 0.2 }}
                            transition={{ duration: 0.6 }}
                        >
                            <p className={'methodDescription'}>The framework for turning
                                brand <span className={'glowork-pink-color'}>potential</span> into
                                progress.</p>
                        </motion.div>
                    </div>

                    <div className={'row glow-steps-row mt-3 mt-lg-5'}>
                        {glowMethods.map((method, index) => (
                            <motion.div
                                className="col-12 col-md-6 col-lg-3 p-0"
                                key={index}
                                initial={{ opacity: 0, y: 50 }}
                                whileInView={{ opacity: 1, y: 0 }}
                                viewport={{ once: false, amount: 0.1 }}
                                transition={{ duration: 0.5, delay: index * 0.15 }}
                            >
                                <div className={`glow-step-card ${index !== glowMethods.length - 1 ? 'border-end' : ''}`}>
                                    <span className="glow-watermark">{method.letter}</span>
                                    <div className="glow-step-content">
                                        <span className="step-num">{method.num}</span>
                                        <h3 className="step-title">{method.title}</h3>
                                        <p className="step-desc">{method.desc}</p>

                                        <button className="btn-circle-arrow mt-auto">
                                            <i className="bi bi-arrow-up-right"></i>
                                        </button>
                                    </div>
                                </div>
                            </motion.div>
                        ))}
                    </div>
                </div>
            </section>

            <section id={'home-service'}>
                <div className={'container py-5 py-lg-5'}>
                    <motion.div
                        className={'text-center'}
                        initial={{ opacity: 0, y: 50 }}
                        whileInView={{ opacity: 1, y: 0 }}
                        viewport={{ once: false, amount: 0.3 }}
                        transition={{ duration: 0.6 }}
                    >
                        <div className="glow-method-wrapper">
                            <h5 className="glowMethod">SERVICE MODAL</h5>
                            <div className="glow-underline-container">
                                <span className="glow-line"></span>
                                <img
                                    src="/site/assets/img/glow-star.png"
                                    alt="Glow Star"
                                    className="glow-star-icon"
                                />
                            </div>
                        </div>
                        <p className={'methodDescription'}>GloworKs operates as a <span
                            className={'glowork-pink-color'}>harbor pilot</span></p>
                        <p className={'text-muted w50to100 m-auto'}>bringing strategic clarity, local expertise, and
                            executional control
                            to
                            guide brands safely into their next phase of growth.
                        </p>

                        <motion.img
                            className={'w75to100 m-auto mt-4'}
                            src={'/site/assets/img/serviceModal.jpg'}
                            alt="Service Modal"
                            initial={{ opacity: 0, scale: 0.95 }}
                            whileInView={{ opacity: 1, scale: 1 }}
                            viewport={{ once: false, amount: 0.3 }}
                            transition={{ duration: 0.6, delay: 0.2 }}
                        />
                    </motion.div>
                </div>
            </section>

            <section id={'home-scope-service'} className={'pb-3 pb-lg-5'}>
                <div className={'container py-5 py-lg-5'}>
                    <div className={'row g-1 g-lg-5'}>
                        <motion.div
                            className={'col-12 col-md-3'}
                            initial={{ opacity: 0, x: -50 }}
                            whileInView={{ opacity: 1, x: 0 }}
                            viewport={{ once: false, amount: 0.2 }}
                            transition={{ duration: 0.6 }}
                        >
                            <div className="glow-method-wrapper">
                                <h5 className="glowMethod">THE SCOPE OF SERVICE</h5>
                                <div className="glow-underline-container">
                                    <span className="glow-line"></span>
                                    <img
                                        src="/site/assets/img/glow-star.png"
                                        alt="Glow Star"
                                        className="glow-star-icon"
                                    />
                                </div>
                            </div>
                            <p className={'text-muted small mb-4'}>
                                GloworKs operates as a harbor pilot,
                                bringing strategic clarity, local expertise,
                                and executional control to guide brands
                                safely into their next phase of growth.
                            </p>
                        </motion.div>
                        <motion.div
                            className={'col-12 col-md-6 '}
                            initial={{ opacity: 0, x: 50 }}
                            whileInView={{ opacity: 1, x: 0 }}
                            viewport={{ once: false, amount: 0.2 }}
                            transition={{ duration: 0.6 }}
                        >
                            <p className={'methodDescription'}>New-Gen Fractional <span
                                className={'glowork-pink-color'}>Business</span> Management
                            </p>
                        </motion.div>
                    </div>

                    <div className="service-list-container mt-3 mt-lg-5">
                        {services.map((service, index) => (
                            <motion.div
                                className="row align-items-center py-4 service-row"
                                key={index}
                                initial={{ opacity: 0, y: 30 }}
                                whileInView={{ opacity: 1, y: 0 }}
                                viewport={{ once: false, amount: 0.1 }}
                                transition={{ duration: 0.5, delay: index * 0.1 }}
                            >
                                <div className="col-1 col-lg-1 text-center text-lg-start">
                                    <span className="service-number">{service.id}</span>
                                </div>
                                <div className="col-9 col-lg-3">
                                    <h4 className="service-title mb-0">{service.title}</h4>
                                </div>
                                <div className="col-12 col-lg-7 mt-3 mt-lg-0 order-4 order-lg-3">
                                    <p className="service-desc mb-0">
                                        {formatServiceDesc(service.desc)}
                                    </p>
                                </div>
                                <div className="col-1 col-lg-1 text-end order-3 order-lg-4">
                                    <button className="btn-service-action">
                                        <i className="bi bi-arrow-up-right btn-icon"></i>
                                    </button>
                                </div>
                            </motion.div>
                        ))}
                    </div>
                </div>
            </section>

            <section id={'home-leadership'}>
                <div className={'container py-5 py-lg-5'}>
                    <div className={'row g-1 g-xl-5'}>
                        <motion.div
                            className={'col-12 col-md-3'}
                            initial={{ opacity: 0, x: -50 }}
                            whileInView={{ opacity: 1, x: 0 }}
                            viewport={{ once: false, amount: 0.2 }}
                            transition={{ duration: 0.6 }}
                        >
                            <div className="glow-method-wrapper">
                                <h5 className="glowMethod">LEADERSHIP TEAM</h5>
                                <div className="glow-underline-container">
                                    <span className="glow-line"></span>
                                    <img
                                        src="/site/assets/img/glow-star.png"
                                        alt="Glow Star"
                                        className="glow-star-icon"
                                    />
                                </div>
                            </div>
                        </motion.div>
                        <motion.div
                            className={'col-12 col-md-6'}
                            initial={{ opacity: 0, y: 50 }}
                            whileInView={{ opacity: 1, y: 0 }}
                            viewport={{ once: false, amount: 0.2 }}
                            transition={{ duration: 0.6, delay: 0.1 }}
                        >
                            <p className={'methodDescription'}>The people who make <span
                                className={'glowork-pink-color'}>the move </span> with you.
                            </p>
                        </motion.div>
                        <motion.div
                            className={'col-12 col-md-3'}
                            initial={{ opacity: 0, x: 50 }}
                            whileInView={{ opacity: 1, x: 0 }}
                            viewport={{ once: false, amount: 0.2 }}
                            transition={{ duration: 0.6, delay: 0.2 }}
                        >
                            <p className={'text-muted small'}>
                                A senior, cross-functional team with deep
                                commercial, e-commerce, brand-building
                                experience in beauty, retail, FMCG fields.
                            </p>
                        </motion.div>
                    </div>

                    <div className={'row g-4 g-xl-3 mt-3 mt-lg-5 mb-lg-5'}>
                        {leaders.map((leader, index) => (
                            <motion.div
                                key={index}
                                className={'col-12 col-lg-3'}
                                initial={{ opacity: 0, y: 50 }}
                                whileInView={{ opacity: 1, y: 0 }}
                                viewport={{ once: false, amount: 0.1 }}
                                transition={{ duration: 0.5, delay: (index + 1) * 0.1 }}
                            >
                                <Link
                                    to={leaderPath(leader)}
                                    className={'position-relative leader-card d-block text-decoration-none'}
                                    onClick={(event) => handleLeaderClick(event, leader)}
                                >
                                    <img className={'w-100'} src={leader.img} alt={leader.name}/>
                                    <div className={'position-absolute bottom-0 p-3 leader-card-info'}>
                                        <h5 className={'leadership-color fw-700 mb-0 leader-card-name'}>{leader.name}</h5>
                                        <p className={'leadership-color mb-3 fw-100 small leader-card-role'}>{leader.role}</p>
                                        <p className={'leadership-color fw-100 small mb-0 leader-card-exp'}>{leader.exp}</p>
                                    </div>
                                    <div className={'position-absolute bottom-0 end-0 p-3'}>
                                        <div className={'border rounded-circle d-flex align-items-center justify-content-center icon-wrapper'} style={{width: '30px', height: '30px', opacity: leader.cv ? 1 : 0.3}}>
                                            <i className="bi bi-arrow-up-right btn-icon leadership-color text-white fs-6"></i>
                                        </div>
                                    </div>
                                </Link>
                            </motion.div>
                        ))}
                    </div>
                </div>
            </section>

            <AnimatePresence>
                {isModalOpen && selectedLeader && (
                    <motion.div
                        className="modal-overlay"
                        initial={{ opacity: 0 }}
                        animate={{ opacity: 1 }}
                        exit={{ opacity: 0 }}
                        style={{
                            position: 'fixed',
                            top: 0, left: 0, right: 0, bottom: 0,
                            backgroundColor: 'rgba(0, 0, 0, 0.8)',
                            zIndex: 9999,
                            display: 'flex',
                            alignItems: 'center',
                            justifyContent: 'center',
                            padding: '20px'
                        }}
                        onClick={closeLeaderModal}
                    >
                        <motion.div
                            className="modal-content-wrapper"
                            initial={{ y: 50, opacity: 0 }}
                            animate={{ y: 0, opacity: 1 }}
                            exit={{ y: 50, opacity: 0 }}
                            style={{
                                backgroundColor: '#111',
                                border: '1px solid #333',
                                borderRadius: '15px',
                                padding: '40px',
                                maxWidth: '800px',
                                width: '100%',
                                maxHeight: '85vh',
                                overflowY: 'auto',
                                overscrollBehavior: 'contain',
                                position: 'relative',
                                color: '#fff'
                            }}
                            onClick={(e) => e.stopPropagation()}
                        >
                            <button
                                onClick={closeLeaderModal}
                                style={{
                                    position: 'absolute', top: '20px', right: '20px',
                                    background: 'none', border: 'none', color: '#fff',
                                    fontSize: '30px', cursor: 'pointer', lineHeight: '1'
                                }}
                            >
                                &times;
                            </button>

                            <div className="d-flex flex-column flex-md-row align-items-center text-center text-md-start mb-4 pb-3 border-bottom border-secondary">
                                <img
                                    src={selectedLeader.img}
                                    alt={selectedLeader.name}
                                    className="mb-3 mb-md-0 me-md-4"
                                    style={{
                                        width: '150px', height: '150px',
                                        flexShrink: 0,
                                        borderRadius: '50%', objectFit: 'cover',
                                        objectPosition: 'top',
                                        border: '2px solid var(--glowork-pink)'
                                    }}
                                />
                                <div>
                                    <h3 className="fw-bold mb-1">{selectedLeader.name}</h3>
                                    <p className="glowork-pink-color fw-500 mb-0">{selectedLeader.role}</p>
                                </div>
                            </div>

                            <div className="cv-content text-light fw-light" style={{ lineHeight: '1.8', fontSize: '0.95rem', opacity: 0.9 }}>
                                {excerpt.paragraphs.map((paragraph, idx, list) => (
                                    <p key={idx} className="mb-3">
                                        {paragraph}
                                        {excerpt.truncated && idx === list.length - 1 ? ' …' : ''}
                                    </p>
                                ))}
                            </div>

                            <div className="d-flex justify-content-center justify-content-md-start pt-4 mt-2 border-top border-secondary">
                                <Link
                                    to={leaderPath(selectedLeader)}
                                    className="btn experienceSeeBtn px-4 py-2 mt-3"
                                    onClick={closeLeaderModal}
                                >
                                    READ FULL PROFILE <i className="bi bi-arrow-up-right btn-icon ms-2"></i>
                                </Link>
                            </div>
                        </motion.div>
                    </motion.div>
                )}
            </AnimatePresence>

            <section id={'home-experience'}>
                <div className={'container py-5 py-lg-5'}>
                    <div className={'d-flex'}>
                        <motion.div
                            className={'ms-0 me-auto'}
                            initial={{ opacity: 0, x: -50 }}
                            whileInView={{ opacity: 1, x: 0 }}
                            viewport={{ once: false, amount: 0.2 }}
                            transition={{ duration: 0.5 }}
                        >
                            <div className="glow-method-wrapper">
                                <h5 className="glowMethodWhite">EXPERIENCE ACROSS</h5>
                                <div className="glow-underline-container">
                                    <span className="glow-line"></span>
                                    <img
                                        src="/site/assets/img/glow-star.png"
                                        alt="Glow Star"
                                        className="glow-star-icon"
                                    />
                                </div>
                            </div>
                        </motion.div>
                    </div>

                    <div className="brand-strip-wrapper">
                        <div className="brand-strip-track">

                            {[...brands, ...brands].map((brand, index) => {

                                const isClone = index >= brands.length;

                                return (
                                    <motion.div

                                        className={`brand-col px-0 ${isClone ? 'brand-clone' : ''}`}
                                        key={index}
                                        initial={{ opacity: 0, y: 30 }}
                                        whileInView={{ opacity: 1, y: 0 }}
                                        viewport={{ once: true, amount: 0.1 }}
                                        transition={{ duration: 0.5, delay: (index % brands.length) * 0.1 }}
                                    >
                                        <div className="brand-item d-flex justify-content-center align-items-center h-100 py-2 py-lg-3">
                                            <img src={brand.img} alt={brand.name} className="brand-logo img-fluid px-3"/>
                                        </div>
                                    </motion.div>
                                );
                            })}
                        </div>
                    </div>
                </div>
            </section>

            <section id={'home-form'}>
                <div className={'container py-5 py-lg-5'}>
                    <div className={'row'}>

                        <motion.div
                            className={'col-12 col-lg-5 mb-3 mb-lg-0'}
                            initial={{ opacity: 0, x: -50 }}
                            whileInView={{ opacity: 1, x: 0 }}
                            viewport={{ once: false, amount: 0.2 }}
                            transition={{ duration: 0.6 }}
                        >
                            <p className={'text-uppercase mb-2 fw-500 glowork-pink-color small'}>
                                LET'S BUILD WHAT GROWS
                            </p>
                            <h2 className={'text-white fw-bold display-4 lh-sm'}>
                                Ready to <span className={'glowork-pink-color'}> scale </span>
                                your brand?
                            </h2>
                        </motion.div>

                        <motion.div
                            className={'col-12 col-lg-7'}
                            initial={{ opacity: 0, x: 50 }}
                            whileInView={{ opacity: 1, x: 0 }}
                            viewport={{ once: false, amount: 0.2 }}
                            transition={{ duration: 0.6 }}
                        >
                            <p className={'d-none d-lg-block text-white mb-4 fw-light'} style={{fontSize: '1rem', opacity: 0.9}}>
                                Let's talk about how Gloworks can support navigate your next phase of<br/>
                                growth, with strategic clarity and senior leadership.
                            </p>

                            <p className={'d-block d-lg-none text-white mb-5 fw-light'} style={{fontSize: '1rem', opacity: 0.9}}>
                                Let's talk about how Gloworks can support navigate your next phase of
                                growth, with strategic clarity and senior leadership.
                            </p>

                            <ContactForm />

                        </motion.div>

                    </div>
                </div>
            </section>
        </>
    );
};

export default Home;